import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const EmptyGuide = ({ subscription }) => {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();

  return (
    <>
      <div className="row">
        {t("Check all our guides to find a suitable setup guide")}
      </div>
      <div
        className="link row"
        onClick={() =>
          navigate("/account/guide/all", {
            state: { subscription: subscription },
          })
        }
      >
        {t("All guides")}
      </div>
    </>
  );
};

export default EmptyGuide;
